export default function FramerPaired() {
	return (
		<div className="flex h-screen flex-col items-center justify-center">
			<h1 className="text-3xl font-bold">
				Iconited Successfully Paired with Framer 🎉
			</h1>
			<p className="text-lg">
				You can now close this window and return to Framer.
			</p>
		</div>
	)
}
